export enum StatusEnum {
    DefaultJobPostingStatus = "14",
    ClientReject = "1",
    Confirmed = "2",
    InterviewRated = "3",
    InterviewRescheduled = "4",
    Interviewscheduled = "5",
    NoInfo = "6",
    NoResponse = "7",
    NoShow = "8",
    NotAvailable = "9",
    NotInterested = "10",
    Panelnotjoined = "11",
    RatingPending = "12",
    JDmismatch = "13",
    Open = "14",
    Closed = "15",
    OnHold = "16",
    Added = "17",
    InProgress = "18",
    Selected = "19",
    Joined = "20",
    Rejected = "21",
    IAIReject = "22",
    TechReject = "23",
    HRReject = "24",
    OfferReject = "25",
    Registered = "26",
    Verified = "27",
    ProfileUpdated = "28",
    StatusUpdated = "29",
    ReadyforInterview = "30"
}

export enum ScreenEnum {
    JobPostingStatus = "ClientRecruiterDashboard",
    AddProfileStatus = "AddProfiles",
    EscalationsStatus = "ClientEscalations"
}